import { el, clear } from '../../utils/dom.js';
import { Reservations, Clients, Responsibles } from '../../api/resources.js';
import { field, readForm } from '../../components/form.js';
import { LineEditor } from '../../components/line-editor.js';
import { ok, err } from '../../components/toast.js';
import { navigate } from '../../router/index.js';

export default async function ReservationsFormPage(outlet) {
  clear(outlet);
  let clients = [], resp = [];
  try {
    [clients, resp] = await Promise.all([
      Clients.list({ limit: 500 }).then((r) => r.data || []),
      Responsibles.list({ limit: 200 }).then((r) => r.data || []),
    ]);
  } catch (ex) { outlet.innerHTML = `<div class="empty">Error: ${ex.message}</div>`; return; }

  outlet.appendChild(el('div', { class: 'page-head' },
    el('h1', {}, 'Nueva reserva'),
    el('a', { href: '#/reservations', class: 'btn ghost' }, '← Volver'),
  ));

  const lineEditor = LineEditor({ withPrice: false, onlyAvailable: false });

  const now = new Date();
  const tomorrow = new Date(now.getTime() + 24 * 60 * 60 * 1000);

  const form = el('form', {
    onsubmit: async (e) => {
      e.preventDefault();
      const d = readForm(form);
      const items = lineEditor.getLines();
      const v = lineEditor.validate();
      if (v) { err(v); return; }
      if (!d.client_id && !d.responsible_id) { err('Selecciona cliente o responsable'); return; }
      try {
        const created = await Reservations.create({
          client_id: d.client_id || undefined,
          responsible_id: d.responsible_id || undefined,
          start_date: new Date(d.start_date).toISOString(),
          end_date:   new Date(d.end_date).toISOString(),
          expires_at: d.expires_at ? new Date(d.expires_at).toISOString() : undefined,
          reason: d.reason || undefined,
          items,
        });
        ok(`Reserva ${created.code} creada`);
        navigate(`/reservations/${created.id}`);
      } catch (ex) { err(ex.message); }
    },
  });

  const card = el('div', { class: 'card mb-4' });
  const grid = el('div', { class: 'form-grid' });
  grid.append(
    field({ name: 'client_id', label: 'Cliente (renta)', type: 'select',
      options: clients.map((c) => ({ value: c.id, label: c.full_name })) }),
    field({ name: 'responsible_id', label: 'Responsable (prestamo)', type: 'select',
      options: resp.map((r) => ({ value: r.id, label: r.full_name })) }),
    field({ name: 'start_date', label: 'Inicio', type: 'datetime-local', required: true, value: toLocalInput(now) }),
    field({ name: 'end_date',   label: 'Fin',    type: 'datetime-local', required: true, value: toLocalInput(tomorrow) }),
    field({ name: 'expires_at', label: 'Expira (auto-vencer)', type: 'datetime-local' }),
    field({ name: 'reason',     label: 'Motivo', type: 'textarea', full: true }),
  );
  card.appendChild(grid);
  form.appendChild(card);

  form.appendChild(lineEditor.root);

  form.appendChild(el('div', { class: 'flex gap-2 justify-between' },
    el('a', { href: '#/reservations', class: 'btn' }, 'Cancelar'),
    el('button', { class: 'btn primary', type: 'submit' }, 'Crear reserva'),
  ));
  outlet.appendChild(form);
}

function toLocalInput(d) {
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
